let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("wQW1L")).then(() => parcelRequire('iLXzZ'));